import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	requestNewOTPAction,
	requestVerifyCodeAction,
	resetStateAction,
} from '../../store/login/actions';
import { OTP_CONFIRMED, PASSWORD_EXIST } from '../../store/login/actionTypes';

import {
	getCheckPhoneExistStatus,
	getCheckValidatePhoneCodeValid,
	getCustomerCode,
	getIsNewAccount,
	getLoginMessage,
	getLoginStatus,
	getPhoneNumber,
	getUserProfile,
} from '../../store/login/selectors';

const ValidateOTP = () => {
	const navigate = useNavigate();
	const [otp, setOTP] = useState('');
	const [outTime, setOutTime] = useState(false);
	const [counter, setCounter] = useState(60);
	const [countTry, setCountTry] = useState(0);
	const dispatch = useDispatch();
	const isCodeValid = useSelector(getCheckValidatePhoneCodeValid);
	const status = useSelector(getCheckPhoneExistStatus);
	const phone = useSelector(getPhoneNumber);
	const customerCode = useSelector(getCustomerCode);
	const loginStatus = useSelector(getLoginStatus);
	const loginMessage = useSelector(getLoginMessage);
	const isNewAccount = useSelector(getIsNewAccount);
	const { t } = useTranslation();
	const profile = useSelector(getUserProfile);

	useEffect(() => {
		if ((!phone && !customerCode) || loginStatus) {
			navigate('/');
		}
	}, [phone, loginStatus, customerCode]);

	useEffect(() => {
		if (counter > 0) {
			setTimeout(() => setCounter(counter - 1), 1000);
		} else {
			setOutTime(true);
		}
	}, [counter]);

	useEffect(() => {
		if (
			isCodeValid &&
			(isNewAccount ||
				status === PASSWORD_EXIST ||
				status === OTP_CONFIRMED)
		) {
			// create new account success && OTP is valid
			navigate('/create-password');
		} else if (isCodeValid && status !== PASSWORD_EXIST) {
			// move to next step: update profile info
			navigate('/update-profile');
		}
	}, [isCodeValid]);

	const handleChangeOTP = (value: string) => {
		setOTP(value);
		// if (value.length === 6) {
		// 	dispatch(
		// 		requestVerifyCodeAction({
		// 			phone: customerCode || phone,
		// 			code: value,
		// 		}),
		// 	);
		// 	setCountTry(countTry + 1);
		// }
	};

	const handleBack = () => {
		dispatch(
			resetStateAction({ phone, customerCode, canForgotPassword: false }),
		);
		window.history.back();
	};

	const requestNewOTP = () => {
		setCounter(60);
		setOutTime(false);
		dispatch(requestNewOTPAction(customerCode || phone));
	};

	return (
		<>
      <div className="page-title mb-2 header-title">{t('section_title_otp_confirmation')}</div>
      {profile && profile.email ? (
        <p className="page-sub-title">
          Mã xác thực đã được gửi đến email <b>{profile.email}</b>
        </p>
      ) : (
        <p className="page-sub-title">
          {t('section_sub_title_otp_confirmation')} <b>{phone}</b>
        </p>
      )}
			<div className="d-flex flex-column">
				<div>
					<OtpInput
						className="otp-input"
						onChange={handleChangeOTP}
						value={otp}
						numInputs={6}
						shouldAutoFocus
						isInputNum={true}
					/>
				</div>
				<div className="text-center mt-4">
					{!outTime ? (
						<div>
							{t('otp_confirmation_message_resend_otp_period_1')}{' '}
							<b>{counter}</b>{' '}
							{t('otp_confirmation_message_resend_otp_period_2')}
						</div>
					) : (
						<div
							onClick={requestNewOTP}
							style={{
								cursor: 'pointer',
								color: '#B3446D',
								fontWeight: '400',
								fontSize: '14px',
							}}
						>
							{t('otp_confirmation_message_resend_otp')}
						</div>
					)}
					{!!loginMessage && <div className="error-msg mt-2">{t(loginMessage)}</div>}
					<div className='mt-2'>
						{profile && profile.email ? (
							<span>Sai email? </span>
						) : (
							<span>
								{t(
									'otp_confirmation_message_wrong_phone_number',
								)}{' '}
							</span>
						)}
						<span
							style={{
								cursor: 'pointer',
								color: '#B3446D',
								fontWeight: '400',
								fontSize: '15px',
							}}
							onClick={() => {
								// dispatch(resetStateAction());
								handleBack();
							}}
						>
							{t(
								'otp_confirmation_message_wrong_phone_number_edit',
							)}
						</span>
					</div>
					{otp?.length === 6 && (
						<Button
							type="primary"
							className='mt-2'
							onClick={() => {
								dispatch(
									requestVerifyCodeAction({
										phone: customerCode || phone,
										code: otp,
									}),
								);
							}}
						>
							{t('otp_confirm')}
						</Button>
					)}
				</div>
			</div>
		</>
	);
};
export default ValidateOTP;
